import { contactData } from '@/mocks/cinema';

export default function SectionContact() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="section-container px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center bg-background-50 rounded-2xl border border-background-200/30 p-8 md:p-12">
          <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-primary-500/10 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-primary-400" />
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-3">
            {contactData.title}
          </h2>
          <p className="text-foreground-500 text-sm leading-relaxed mb-6 max-w-md mx-auto">
            {contactData.description}
          </p>
          <p className="text-base font-medium text-primary-400">
            {contactData.email}
          </p>
        </div>
      </div>
    </section>
  );
}